import {
    get,
    post,
    del,
    getFile,
    jsonget
} from '@/utils/request'
//文件上传接口
export const UPLOAD_API = `${process.env.VUE_APP_BASE_API}/oss/upload`;

//文件上传接口
export const UPLOAD_VIDEO_API = `${process.env.VUE_APP_BASE_API}/sys/appeal/videoUpload`;

//评论批量上传 
export const UPLOAD_COMMENT_API = `${process.env.VUE_APP_BASE_API}/web/comment/pv/savePvList`;
//获取OSS配置
export const getOssData = params => {
    return post(`/admin/oss/config/params`, params).then(res => res.data)
};
//登录
export const login = params => {
    return post(`/admin/security/login`, params).then(res => res.data)
};
//微赞登录
export const login2vz = params => {
    return get(`/api/user/login2vz`, params).then(res => res.data)
};
//退出
export const logout = params => {
    return get(`/admin/account/login/out`, params).then(res => res.data)
};
//通过课程id去查询课程目录信息
export const queryFindCourse = params => {
    return post(`/happiness/Admin/AdminClassgrade/findCourse`, params).then(res => res.data)
};
//查询教室管理列表
export const queryClassroomList = params => {
    return post(`/admin/classroom/list`, params).then(res => res.data)
};
//查询校区管理列表
export const queryCampusList = params => {
    return post(`/tim/admin/AdminCampus/list`, params).then(res => res.data)
};
//教室管理添加
export const addClassroomOperation = params => {
    return post(`/admin/classroom/add`, params).then(res => res.data)
};
//教室管理编辑
export const editClassroomOperation = params => {
    return post(`/admin/classroom/save`, params).then(res => res.data)
};
//教室管理删除
export const classroomDelete = params => {
    return post(`/admin/classroom/del`, params).then(res => res.data)
};
//教室管理关闭
export const classroomClose = params => {
    return post(`/admin/classroom/close`, params).then(res => res.data)
};
//教室管理开启
export const classroomOpen = params => {
    return post(`/admin/classroom/open`, params).then(res => res.data)
};
//教室管理批量修改状态
export const classroomChangeState = params => {
    return post(`/tim/admin/AdminClassRoom/upstatus`, params).then(res => res.data)
};


//查询班级管理列表
export const queryClassgradeList = params => {
    return post(`/happiness/Admin/AdminClassgrade/list`, params).then(res => res.data)
};
//添加班级管理
export const addClassgradeOperation = params => {
    return post(`/happiness/Admin/AdminClassgrade/insert`, params).then(res => res.data)
};
//老师管理列表
export const queryTeacherList = params => {
    return post(`/tim/admin/AdminTeacher/list`, params).then(res => res.data)
};
//课程管理列表
export const queryCourseList = params => {
    return post(`/tim/admin/AdminCourse/list`, params).then(res => res.data)
};
//班级删除
export const classGradeDelete = params => {
    return post(`/happiness/Admin/AdminClassgrade/delete`, params).then(res => res.data)
};
//编辑班级管理
export const editClassgradeOperation = params => {
    return post(`/happiness/Admin/AdminClassgrade/update`, params).then(res => res.data)
};


//查询学员管理列表
export const queryStudentList = params => {
    return post(`/happiness/Admin/AdminStudent/list`, params).then(res => res.data)
};
//添加学员管理
export const addStudentOperation = params => {
    return post(`/admin/stu/add`, params).then(res => res.data)
};
//编辑学员管理
export const editStudentOperation = params => {
    return post(`/happiness/Admin/AdminStudent/update`, params).then(res => res.data)
};
//删除学员管理
export const studentDelete = params => {
    return post(`/admin/stu/delete`, params).then(res => res.data)
};

//查询排课管理列表
export const queryArrangementList = params => {
    return post(`/happiness/Admin/AdminGradeRecord/list`, params).then(res => res.data)
};
//添加排课管理
export const addArrangementOperation = params => {
    return post(`/happiness/Admin/AdminGradeRecord/insertBatch`, params).then(res => res.data)
};
//编辑排课管理
export const editArrangementOperation = params => {
    return post(`/tim/admin/AdminCourseSchedu/edit`, params).then(res => res.data)
};
//删除排课记录
export const arrangementDelete = params => {
    return post(`/happiness/Admin/AdminGradeRecord/delete`, params).then(res => res.data)
};

//添加老师管理
export const addTearchOperation = params => {
    return post(`/tim/admin/AdminTeacher/add`, params).then(res => res.data)
};
//编辑老师管理
export const editDeleteTearchOperation = params => {
    return post(`/tim/admin/AdminTeacher/edit`, params).then(res => res.data)
};
//编辑老师管理
export const DeleteTearchOperation = params => {
    return post(`/tim/admin/AdminTeacher/del`, params).then(res => res.data)
};
//添加学员课程
export const addStudentCourseOperation = params => {
    return post(`/tim/admin/AdminCourseUser/add`, params).then(res => res.data)
};
//添加学员课程
export const editStudentCourseOperation = params => {
    return post(`/tim/admin/AdminCourseUser/edit`, params).then(res => res.data)
};
//学员课程列表
export const queryStudentCourseList = params => {
    return post(`/tim/admin/AdminCourseUser/list`, params).then(res => res.data)
};
//学员课程删除
export const studentCourseDelete = params => {
    return post(`/tim/admin/AdminCourseUser/del`, params).then(res => res.data)
};

//审核管理
export const queryAuditList = params => {
    return post(`/admin/cer/list`, params).then(res => res.data)
};
//审核修改
export const editAuditList = params => {
    return post(`/admin/cer/edit`, params).then(res => res.data)
};


//顾问管理
export const queryCounselorList = params => {
    return post(`/tim/admin/AdminCounselor/list`, params).then(res => res.data)
};
//添加顾问管理
export const addCounselorOperation = params => {
    return post(`/tim/admin/AdminCounselor/add`, params).then(res => res.data)
};
//删除顾问管理
export const deleteCounselorOperation = params => {
    return post(`/tim/admin/AdminCounselor/del`, params).then(res => res.data)
};
//编辑顾问管理
export const editCounselorOperation = params => {
    return post(`/tim/admin/AdminCounselor/edit`, params).then(res => res.data)
};
//添加学员报班
export const addStudentGradeOperation = params => {
    return post(`/happiness/Admin/AdminGradeUser/insert`, params).then(res => res.data)
};
//学员报班列表
export const queryStudentGrade = params => {
    return post(`/happiness/Admin/AdminGradeUser/list`, params).then(res => res.data)
};
//学员报班开关
export const queryStudentIsOpen = params => {
    return post(`/happiness/Admin/AdminGradeUser/isOpen`, params).then(res => res.data)
};
//学员报班删除
export const deleteStudentGradeOperation = params => {
    return post(`/tim/admin/AdminClassGradeUser/del`, params).then(res => res.data)
};
//学员报班编辑
export const editStudentGradeOperation = params => {
    return post(`/tim/admin/AdminClassGradeUser/edit`, params).then(res => res.data)
};
//班级排课记录列表
export const queryCourseSchedulingList = params => {
    return post(`/tim/admin/AdminCourseRecord/list`, params).then(res => res.data)
};
//班级排课记录添加
export const addCourseSchedulingOperation = params => {
    return post(`/tim/admin/AdminCourseRecord/add`, params).then(res => res.data)
};
//班级排课记录删除
export const deleteCourseSchedulingOperation = params => {
    return post(`/tim/admin/AdminCourseRecord/del`, params).then(res => res.data)
};
//班级排课记录编辑
export const editCourseSchedulingOperation = params => {
    return post(`/tim/admin/AdminCourseRecord/edit`, params).then(res => res.data)
};
//班级排课记录编辑
export const allLeaveOperation = params => {
    return post(`/tim/admin/AdminCourseRecord/upToTake`, params).then(res => res.data)
};
//班级排课记录列表
export const queryClassGradeUser = params => {
    return post(`/happiness/Admin/AdminGradeUser/record`, params).then(res => res.data)
};
// 上传复习视频
export const uploadingVideoUrl = params => {
    return post(`/happiness/Admin/AdminGradeRecord/review`, params).then(res => res.data)
};


// 角色管理列表
export const queryRoleList = params => {
    return post(`/happiness/Admin/AdminRole/list`, params).then(res => res.data)
};
// 添加角色管理
export const addRoleOperation = params => {
    return post(`/happiness/Admin/AdminRole/insert`, params).then(res => res.data)
};
// 编辑角色管理
export const editRoleOperation = params => {
    return post(`/happiness/Admin/AdminRole/update`, params).then(res => res.data)
};
// 删除角色管理
export const deleteRoleOperation = params => {
    return post(`/happiness/Admin/AdminRole/delete`, params).then(res => res.data)
};

// 账号管理列表
export const queryAccountList = params => {
    return post(`/tim/admin/AdminAccount/list`, params).then(res => res.data)
};
// 账号管理列表
export const giveAccountOperation = params => {
    return post(`/tim/admin/AdminAccount/putRole`, params).then(res => res.data)
};

// 根据token获取栏目
export const queryColumnList = params => {
    return post(`/happiness/Admin/AdminRule/index`, params).then(res => res.data)
};

// 查看角色权限
export const lookRoleAdmin = params => {
    return post(`/happiness/Admin/AdminRole/select`, params).then(res => res.data)
};
// 授予角色权限
export const impowerRoleAdmin = params => {
    return post(`/happiness/Admin/AdminRole/put`, params).then(res => res.data)
};

// 排课记录请假
export const handleUserTakeLeave = params => {
    return post(`/happiness/Admin/AdminGradeUser/leaveRecord`, params).then(res => res.data)
};
// 排课记录核销
export const handleAdminGradeUserVerify = params => {
    return post(`/happiness/Admin/AdminGradeUser/verify`, params).then(res => res.data)
};

// 核销列表
export const queryAdminVerifyList = params => {
    return post(`/happiness/Admin/AdminVerify/list`, params).then(res => res.data)
};


// 活动管理列表
export const queryActivityList = params => {
    return post(`/tim/admin/AdminActivity/list`, params).then(res => res.data)
};
// 活动管理添加
export const addActivityOperation = params => {
    return post(`/tim/admin/AdminActivity/add`, params).then(res => res.data)
};
// 活动管理删除
export const deleteActivityOperation = params => {
    return post(`/tim/admin/AdminActivity/del`, params).then(res => res.data)
};
// 活动管理编辑
export const editActivityOperation = params => {
    return post(`/tim/admin/AdminActivity/edit`, params).then(res => res.data)
};

// 商品管理列表
export const queryCommodityList = params => {
    return post(`/happiness/Admin/AdminMall/goodsList`, params).then(res => res.data)
};
// 商品管理添加
export const addCommodityOperation = params => {
    return post(`/happiness/Admin/AdminMall/goodsAdd`, params).then(res => res.data)
};
// 商品管理删除
export const deleteCommodityOperation = params => {
    return post(`/happiness/Admin/AdminMall/goodsDelete`, params).then(res => res.data)
};
// 商品管理编辑
export const editCommodityOperation = params => {
    return post(`/happiness/Admin/AdminMall/goodsUpdate`, params).then(res => res.data)
};
// 商品管理上下架
export const commodityPutawayOperation = params => {
    return post(`/happiness/Admin/AdminMall/goodsUpShelf`, params).then(res => res.data)
};
// 商品管理详情
export const commodityDetailsOperation = params => {
    return post(`/happiness/Admin/AdminMall/goodsInfo`, params).then(res => res.data)
};
// 商品规格删除
export const handleGoodsSpecificDel = params => {
    return post(`/happiness/Admin/AdminMall/goodsSpecificDel`, params).then(res => res.data)
};
// 商品规格修改
export const handleGoodsSpecificUp = params => {
    return post(`/happiness/Admin/AdminMall/goodsSpecificUp`, params).then(res => res.data)
};
// 商品的单个素材新增
export const handleGoodsMaterialAdd = params => {
    return post(`/happiness/Admin/AdminMall/goodsMaterialAdd`, params).then(res => res.data)
};
// 商品的单个素材删除
export const handleGoodsMaterialDel = params => {
    return post(`/happiness/Admin/AdminMall/goodsMaterialDel`, params).then(res => res.data)
};
// 商品的单个详情新增
export const handleGoodsDetailAdd = params => {
    return post(`/happiness/Admin/AdminMall/goodsDetailAdd`, params).then(res => res.data)
};
// 商品的单个详情删除
export const handleGoodsDetailDel = params => {
    return post(`/happiness/Admin/AdminMall/goodsDetailDel`, params).then(res => res.data)
};
// 商城订单列表
export const queryGoodsOrderList = params => {
    return post(`/happiness/Admin/AdminMall/orderList`, params).then(res => res.data)
};
// 商城订单发货
export const handleOrderDelivery = params => {
    return post(`/happiness/Admin/AdminMall/orderDelivery`, params).then(res => res.data)
};
// 获取快递公司列表
export const queryDeliveryCom = params => {
    return post(`/happiness/Admin/AdminMall/getDeliveryCom`, params).then(res => res.data)
};
// 查看物流
export const lookExpressInfo = params => {
    return post(`/happiness/Admin/AdminMall/getExpressInfo`, params).then(res => res.data)
};
// 用户提现记录
export const queryUserCaseRecord = params => {
    return post(`/admin/transfer/transfer/record`, params).then(res => res.data)
};
// 用户提现订单
export const queryUserCaseOrder = params => {
    return post(`/admin/transfer/order/record`, params).then(res => res.data)
};
// 兑换列表
export const queryAdminMallGoods = params => {
    return post(`/tim/admin/AdminMallGoods/orders`, params).then(res => res.data)
};
// 兑换列表
export const handleAdminMallStatus = params => {
    return post(`/tim/admin/AdminMallGoods/status`, params).then(res => res.data)
};
// 添加课程的直播房间号
export const handleCourseRoomId = params => {
    return post(`/tim/admin/AdminCourseRecord/num`, params).then(res => res.data)
};
// 撤回请假
export const handleRevocation = params => {
    return post(`/tim/admin/AdminClassGradeUser/unTakeLeave`, params).then(res => res.data)
};
// 后端添加班级时提供接口
export const handleAddProduction = params => {
    return get(`/admin/message/production`, params).then(res => res.data)
};
// 校区管理列表
export const queryCampusAdminList = params => {
    return post(`/admin/campus/list`, params).then(res => res.data)
};
// 校区管理关闭
export const handleCampusAdminClose = params => {
    return post(`/admin/campus/close`, params).then(res => res.data)
};
// 校区管理开启
export const handleCampusAdminOpen = params => {
    return post(`/admin/campus/open`, params).then(res => res.data)
};
// 校区管理添加
export const handleCampusAdminAdd = params => {
    return post(`/admin/campus/add`, params).then(res => res.data)
};
// 校区管理编辑
export const handleCampusAdminedit = params => {
    return post(`/admin/campus/save`, params).then(res => res.data)
};
// 课程管理目录列表
export const queryCourseAdminList = params => {
    return post(`/admin/course/catalog/list`, params).then(res => res.data)
};
// 课程目录管理添加
export const handleCourseAdminAdd = params => {
    return post(`/admin/course/catalog/add`, params).then(res => res.data)
};
// 课程目录管理删除
export const handleCourseAdminDelete = params => {
    return post(`/admin/course/catalog/del`, params).then(res => res.data)
};
// 课程目录管理编辑
export const handleCourseAdminEdit = params => {
    return post(`/admin/course/catalog/save`, params).then(res => res.data)
};
// 课程管理列表
export const queryCatalogueCourseAdminList = params => {
    return post(`/admin/course/list`, params).then(res => res.data)
};
// 查询校区课程管理列表
export const queryCampusCourseAdminList = params => {
    return post(`/admin/course/list`, params).then(res => res.data)
};
// 课程管理添加
export const handleCatalogueCourseAdminAdd = params => {
    return post(`/admin/course/add`, params).then(res => res.data)
};
// 课程管理编辑
export const handleCatalogueCourseAdminEdit = params => {
    return post(`/admin/course/save`, params).then(res => res.data)
};
// 课程管理删除
export const handleCatalogueCourseAdminDelete = params => {
    return post(`/admin/course/del`, params).then(res => res.data)
};
// 校区课程管理
export const queryCampusCourse = params => {
    return post(`/admin/course/list`, params).then(res => res.data)
};
// 校区课程绑定
export const handleCampusCourseBind = params => {
    return post(`/admin/course/bind`, params).then(res => res.data)
};
// 收费管理列表
export const queryAdminOrderList = params => {
    return post(`/admin/order/list`, params).then(res => res.data)
};
// 收费管理到处excel
export const handleOrderExport = params => {
    return post(`/admin/order/export`, params).then(res => res.data)
};

// 套餐管理列表
export const queryAdminMealList = params => {
    return post(`/happiness/Admin/AdminMeal/list`, params).then(res => res.data)
};
// 套餐添加
export const handleAdminMealAdd = params => {
    return post(`/happiness/Admin/AdminMeal/insert`, params).then(res => res.data)
};
// 套餐编辑
export const handleAdminMealEdit = params => {
    return post(`/happiness/Admin/AdminMeal/update`, params).then(res => res.data)
};
// 套餐删除
export const handleAdminMealDelete = params => {
    return post(`/happiness/Admin/AdminMeal/delete`, params).then(res => res.data)
};
// 套餐sku删除
export const handleAdminMealDeleteSku = params => {
    return post(`/happiness/Admin/AdminMeal/deleteSku`, params).then(res => res.data)
};
// 套餐sku编辑
export const handleAdminMealEditSku = params => {
    return post(`/happiness/Admin/AdminMeal/updateSku`, params).then(res => res.data)
};
// 套餐详情
export const handleAdminMealInfo = params => {
    return post(`/happiness/Admin/AdminMeal/info`, params).then(res => res.data)
};
// 校区套餐绑定
export const handleAdminMealBinding = params => {
    return post(`/happiness/Admin/AdminMeal/bindMeal`, params).then(res => res.data)
};
// 校区的套餐管理列表
export const queryAdminCampusMealList = params => {
    return get(`/admin/order/get/product`, params).then(res => res.data)
};


// 订单列表
export const queryAdminOrder = params => {
    return post(`/happiness/Admin/AdminOrder/list`, params).then(res => res.data)
};

//查询此学员在这班级的所有排课记录
export const queryFindGradeRecord = params => {
    return post(`/happiness/Admin/AdminGradeUser/findGradeRecord`, params).then(res => res.data)
};
//给学员单独添加多个课程
export const handleAddUserRecord = params => {
    return post(`/happiness/Admin/AdminGradeUser/addUserRecord`, params).then(res => res.data)
};

// 乐龄圈超管用户列表
export const queryAdminLelqUser = params => {
    return post(`/admin/user/list/toAdmin`, params).then(res => res.data)
};
// 乐龄圈校长用户列表
export const queryHeadmasterAdminLelqUser = params => {
    return post(`/admin/user/list`, params).then(res => res.data)
};
// 乐龄圈角色列表
export const queryLelqRoles = params => {
    return post(`/admin/user/roles`, params).then(res => res.data)
};
// 乐龄圈角色修改
export const handleLelqRoleAllot = params => {
    return post(`/admin/user/role/allot`, params).then(res => res.data)
};
// 乐龄圈顾问、老师、校长绑定校区
export const handleRoleBinding = params => {
    return post(`/admin/user/campusBind`, params).then(res => res.data)
};



// 活动列表
export const queryListActivity = params => {
    return post(`/happiness/Admin/AdminActivity/listActivity`, params).then(res => res.data)
};
// 活动查看详情列表
export const queryDetailActivity = params => {
    return post(`/happiness/Admin/AdminActivity/detailActivity`, params).then(res => res.data)
};
// 删除活动
export const handleDelActivity = params => {
    return post(`/happiness/Admin/AdminActivity/delActivity`, params).then(res => res.data)
};


// 目录和课程
export const queryCatalogCourse = params => {
    return post(`/admin/course/catalog/list`, params).then(res => res.data)
};
// 游客转学员
export const handleTouristToStudent = params => {
    return post(`/happiness/Admin/AdminStudent/visitorToStudent`, params).then(res => res.data)
};
// 用户转学员
export const handleUserToStudent = params => {
    return post(`/happiness/Admin/AdminStudent/userToStudent`, params).then(res => res.data)
};


// 校区排课记录列表
export const queryByCampus = params => {
    return post(`/admin/arrange/list/byCampus`, params).then(res => res.data)
};
// 排课删除
export const handleDeleteByCampus = params => {
    return post(`/admin/arrange/delete/byCampus`, params).then(res => res.data)
};
// 排课一键核销
export const handleVerifyByCampus = params => {
    return post(`/admin/arrange/verify/all`, params).then(res => res.data)
};
// 校区排课详情
export const queryArrangeDetail = params => {
    return post(`/admin/arrange/detail`, params).then(res => res.data)
};
// 学员上课状态编辑
export const handleStudentEdit = params => {
    return post(`/admin/arrange/student/edit`, params).then(res => res.data)
};
// 排课编辑
export const handlebyCampusEdit = params => {
    return post(`/admin/arrange/edit/byCampus`, params).then(res => res.data)
};
// 批量操作学员核销
export const handleMultiEdit = params => {
    return post(`/admin/arrange/multi/edit`, params).then(res => res.data)
};


// 商城订单自提
export const handleOrderPickup = params => {
    return post(`/happiness/Admin/AdminMall/orderPickup`, params).then(res => res.data)
};
// 班级学员
export const queryClassStudent = params => {
    return post(`/happiness/Admin/AdminClassgrade/getClassStudent`, params).then(res => res.data)
};
// 班级学员
export const queryAllStudent = params => {
    return post(`/happiness/Admin/AdminClassgrade/getAllStudent`, params).then(res => res.data)
};
// 批量添加班级学员
export const handleInsertBatch = params => {
    return post(`/happiness/Admin/AdminClassgrade/insertBatch`, params).then(res => res.data)
};


// 校区顾问老师列表
export const queryWorkerList = params => {
    return post(`/admin/campus/worker/list`, params).then(res => res.data)
};
// 校区顾问老师删除
export const handleWorkerDel = params => {
    return post(`/admin/campus/worker/del`, params).then(res => res.data)
};
// 校区顾问老师删除
export const handleWorkerAdd = params => {
    return post(`/admin/campus/worker/add`, params).then(res => res.data)
};


// 学员班级编辑
export const handleAdminGradeUserEdit = params => {
    return post(`/happiness/Admin/AdminGradeUser/edit`, params).then(res => res.data)
};


// 赠送列表
export const queryTicketList = params => {
    return post(`/admin/user/ticket/list`, params).then(res => res.data)
};


// 排课管理-学员详情-一键请假
export const handleLeaveAll = params => {
    return post(`/admin/arrange/leave/all`, params).then(res => res.data)
};


// 校区活动退款
export const handleActivityRefund = params => {
    return post(`/happiness/Admin/AdminActivity/activityRefund`, params).then(res => res.data)
};


// 商城订单申请退款
export const handleOrderRefund = params => {
    return post(`/happiness/Admin/AdminMall/orderRefund`, params).then(res => res.data)
};


// 上传完复习视频，通知后端
export const handleVideoUploadNotice = params => {
    return post(`/admin/class/videoUpload/notice`, params).then(res => res.data)
};


// 最近生日的学员
export const queryRemindBirth = params => {
    return post(`/admin/user/remind/birth`, params).then(res => res.data)
};


// 最近需要续费的学员
export const queryRemindExpired = params => {
    return post(`/admin/user/remind/expired`, params).then(res => res.data)
};


// 编辑校区顾问/老师信息
export const handleWorkerEdit = params => {
    return post(`/admin/campus/worker/edit`, params).then(res => res.data)
};


// 数据统计
export const queryStatistics = params => {
    return post(`/admin/statistics/pageByTime`, params).then(res => res.data)
};


// 课程退款
export const handleCourseOrderRefund = params => {
    return post(`/happiness/Admin/AdminOrder/orderRefund`, params).then(res => res.data)
};


// 操作日志
export const queryPageForAdmin = params => {
    return post(`/admin/log/pageForAdmin`, params).then(res => res.data)
};

// 推荐详情
export const queryInviteRelation = params => {
    return post(`/admin/user/invite/relation`, params).then(res => res.data)
};

// 开通服务商
export const handleUserAgent = params => {
    return get(`/admin/user/activate_agent`, params).then(res => res.data)
};

// 取消开通服务商
export const handleUserDeactivateAgent = params => {
    return get(`/admin/user/deactivate_agent`, params).then(res => res.data)
};

// 用户实名
export const handleSetUserRealName = params => {
    return get(`/admin/user/set_realName`, params).then(res => res.data)
};


// 更改服务商
export const handleUserRebindAgent = params => {
    return get(`/admin/user/rebind_agent`, params).then(res => res.data)
};

// 更改服务商等级
export const handleUserAgentChangeLevel = params => {
    return get(`/admin/user/agent_level_up`, params).then(res => res.data)
};

// 服务商层级列表
export const queryUserAgentRelationList = params => {
    return get(`/admin/user/agent_relation_list`, params).then(res => res.data)
};

// 服务商层级修改
export const handleUserAgentRelationSave = params => {
    return get(`/admin/user/agent_relation_save`, params).then(res => res.data)
};

// 服务商列表
export const handleGoldAgentList = params => {
    return post(`/admin/gold/agent_list`, params).then(res => res.data)
};

// 服务商用户列表
export const queryGoldAgentTeamList = params => {
    return post(`/admin/gold/agent_team_list`, params).then(res => res.data)
};

// 合伙人列表
export const queryGoldPartnerList = params => {
    return post(`/admin/gold/partner_list`, params).then(res => res.data)
};

// 合伙人团队列表
export const queryGoldPartnerTeamList = params => {
    return post(`/admin/gold/partner_team_list`, params).then(res => res.data)
};

// 视频课程添加
export const handleVideoCourseAdd = params => {
    return post(`/admin/video/course/add`, params).then(res => res.data)
};

// 视频课程编辑
export const handleVideoCourseEdit = params => {
    return post(`/admin/video/course/edit`, params).then(res => res.data)
};
// 视频课程列表
export const queryVideoCourseList = params => {
    return post(`/admin/video/course/list`, params).then(res => res.data)
};
// 视频课程删除
export const handleVideoCourseDelete = params => {
    return post(`/admin/video/course/del`, params).then(res => res.data)
};
// 视频课程下架
export const handleVideoCourseBan = params => {
    return post(`/admin/video/course/ban`, params).then(res => res.data)
};
// 视频课程学员详情
export const queryVideoCourseStudentList = params => {
    return post(`/admin/video/course/students`, params).then(res => res.data)
};
// 视频课程目录列表
export const queryVideoCatalogList = params => {
    return post(`/admin/video/course/catalog/list`, params).then(res => res.data)
};
// 添加视频课程目录列表
export const handleVideoCatalogAdd = params => {
    return post(`/admin/video/course/catalog/add`, params).then(res => res.data)
};
// 视频课程目录删除
export const handleVideoCatalogDelete = params => {
    return post(`/admin/video/course/catalog/del`, params).then(res => res.data)
};
// 视频课程目录编辑
export const handleVideoCatalogEdit = params => {
    return post(`/admin/video/course/catalog/edit`, params).then(res => res.data)
};
// 视频课程目录学员详情列表
export const queryVideoCatalogStudentsList = params => {
    return post(`/admin/video/course/catalog/students`, params).then(res => res.data)
};
// 学期制学员班级-换班
export const handleChangeClass = params => {
    return post(`/happiness/Admin/AdminGradeUser/changeClass`, params).then(res => res.data)
};
// 金币模块广告管理
export const queryGoldAdDataMonitor = params => {
    return post(`/admin/gold/ad_data_monitor`, params).then(res => res.data)
};
// 广告数据监控ymd明细
export const queryGoldAdDataMonitorYmd = params => {
    return post(`/admin/gold/ad_data_monitor_ymd`, params).then(res => res.data)
};
// 广告数据监控用户明细
export const queryGoldAdDataMonitorUser = params => {
    return post(`/admin/gold/ad_data_monitor_user`, params).then(res => res.data)
};
// 比赛管理添加
export const handleMatchAdd = params => {
    return post(`/admin/match/add`, params).then(res => res.data)
};
// 比赛选手添加
export const handleMatchPlayerAdd = params => {
    return post(`/admin/match/add_player`, params).then(res => res.data)
};
// 比赛选手编辑
export const handleMatchPlayerEdit = params => {
    return post(`/admin/match/edit_player`, params).then(res => res.data)
};
// 比赛分组
export const getMatchGroupList = params => {
    return get(`/admin/match/get_group`, params).then(res => res.data)
};
// 比赛管理列表
export const queryMatchList = params => {
    return post(`/admin/match/list`, params).then(res => res.data)
};
// 比赛管理设置ecpm
export const handleMatchSetEcpm = params => {
    return post(`/admin/match/set_daily_ad_ecpm`, params).then(res => res.data)
};
// 比赛管理ecpm列表
export const queryMatchSetEcpm = params => {
    return post(`/admin/match/get_daily_ad_ecpm`, params).then(res => res.data)
};
// 比赛数据统计
export const queryMatchDataMonitor = params => {
    return post(`/admin/match/data_monitor`, params).then(res => res.data)
};
// 比赛管理删除
export const handleMatchDel = params => {
    return post(`/admin/match/del`, params).then(res => res.data)
};
// 比赛管理编辑
export const handleMatchEdit = params => {
    return post(`/admin/match/edit`, params).then(res => res.data)
};
// 比赛管理参赛详情
export const queryMatchUsers = params => {
    return post(`/admin/match/player_list`, params).then(res => res.data)
};
// 比赛添加投票票数
export const queryMatchUsersAddVote = params => {
    return get(`/admin/match/add_vote`, params).then(res => res.data)
};
// 排课记录停课
export const handleArrangeStop = params => {
    return post(`/admin/arrange/stop/byCampus`, params).then(res => res.data)
};
// 活动添加
export const handleActivityAdd = params => {
    return post(`/happiness/Admin/AdminActivity/addActivity`, params).then(res => res.data)
};
// 活动编辑
export const handleActivityEdit = params => {
    return post(`/happiness/Admin/AdminActivity/editActivity`, params).then(res => res.data)
};
// 栏目添加
export const handleColumnAdd = params => {
    return post(`/admin/banner/catalog/add`, params).then(res => res.data)
};
// 栏目列表
export const queryBannerColumnList = params => {
    return post(`/admin/banner/catalog/list`, params).then(res => res.data)
};
// 栏目添加
export const handleColumnEdit = params => {
    return post(`/admin/banner/catalog/update`, params).then(res => res.data)
};
// 广告列表
export const queryAdvertisingList = params => {
    return post(`/admin/banner/list`, params).then(res => res.data)
};
// 广告添加
export const handleAdvertisingAdd = params => {
    return post(`/admin/banner/add`, params).then(res => res.data)
};
// 图片查询路径
export const handleImageUpload = params => {
    return post(`/admin/file/image/upload`, params).then(res => res.data)
};
// 栏目编辑
export const handleAdvertisingUpdate = params => {
    return post(`/admin/banner/update`, params).then(res => res.data)
};
// 作品列表
export const queryWorksList = params => {
    return post(`/admin/works/list`, params).then(res => res.data)
};
// 作品删除
export const handleWorksDel = params => {
    return post(`/admin/works/del`, params).then(res => res.data)
};
// 作品下架
export const handleWorksDelistWork = params => {
    return post(`/admin/works/delist_work`, params).then(res => res.data)
};
// 作品评论列表
export const handleWorksCommentList = params => {
    return post(`/admin/works/comment_list`, params).then(res => res.data)
};
// 作品评论下架
export const handleWorksDelComment = params => {
    return post(`/admin/works/del_comment`, params).then(res => res.data)
};
// 查询图文作品的图片
export const queryWorkDetailImageList = params => {
    return post(`/admin/works/detail_image_list`, params).then(res => res.data)
};
// 作品推荐
export const handleSetRecommend = params => {
    return post(`/admin/works/setRecommend`, params).then(res => res.data)
};
// 作品批量推荐
export const handleBatchSetRecommend = params => {
    return post(`/admin/works/batch_setRecommend`, params).then(res => res.data)
};
// 添加跟团
export const handleTourAdd = params => {
    return post(`/admin/tour/add`, params).then(res => res.data)
};
// 跟团列表
export const queryTourList = params => {
    return post(`/admin/tour/list`, params).then(res => res.data)
};
// 编辑跟团
export const handleTourUpdate = params => {
    return post(`/admin/tour/update`, params).then(res => res.data)
};
// 跟团人员
export const queryTourUserList = params => {
    return post(`/admin/tour/user/list`, params).then(res => res.data)
};
// 跟团人员
export const handleTourOrderRefund = params => {
    return post(`/happiness/Admin/AdminOrder/tourOrderRefund`, params).then(res => res.data)
};
// 添加作品
export const handleworksAdd = params => {
    return post(`/admin/works/add`, params).then(res => res.data)
};
// 上传作品
export const handleworksUpload = params => {
    return post(`/admin/file/works/upload`, params).then(res => res.data)
};
// 话题
export const handleworksTopicType = params => {
    return get(`/admin/works/topicType`, params).then(res => res.data)
};
// 获取虚拟用户
export const queryRobotList = params => {
    return post(`/admin/user/robot/list`, params).then(res => res.data)
};
// 禁用用户
export const handleUserBan = params => {
    return post(`/admin/user/ban`, params).then(res => res.data)
};






// new API *****

// 添加大专栏
export const handleColumAdd = params => {
    return post(`/admin/courseV2/column/add`, params).then(res => res.data)
};
// 编辑大专栏
export const handleColumEdit = params => {
    return post(`/admin/courseV2/column/edit`, params).then(res => res.data)
};
// 专栏大列表
export const queryColumList = params => {
    return post(`/admin/courseV2/column/list`, params).then(res => res.data)
};
// 添加专栏
export const handleCatalogAdd = params => {
    return post(`/admin/courseV2/catalog/add`, params).then(res => res.data)
};
// 编辑专栏
export const handleCatalogEdit = params => {
    return post(`/admin/courseV2/catalog/edit`, params).then(res => res.data)
};
// 专栏大列表
export const queryCatalogList = params => {
    return post(`/admin/courseV2/catalog/list`, params).then(res => res.data)
};
// 添加课程
export const handleCourseAdd = params => {
    return post(`/admin/courseV2/course/add`, params).then(res => res.data)
};
// 编辑课程
export const handleCourseEdit = params => {
    return post(`/admin/courseV2/course/edit`, params).then(res => res.data)
};
// 课程列表
export const queryCourseV2List = params => {
    return post(`/admin/courseV2/course/list`, params).then(res => res.data)
};
// 目录-课程列表
export const queryCatalogCourseV2List = params => {
    return post(`/admin/courseV2/catalog/courseList`, params).then(res => res.data)
};
// 目录绑定课程
export const handleBindCourse = params => {
    return post(`/admin/courseV2/catalog/bind_course`, params).then(res => res.data)
};
// 查询专栏下绑定的目录
export const queryFindById = params => {
    return get(`/admin/courseV2/column/findById`, params).then(res => res.data)
};
// 全选操作
export const handleOperate = params => {
    return post(`/admin/courseV2/batch/operate`, params).then(res => res.data)
};
// base64格式转换
export const handleImageBase64 = params => {
    return post(`/admin/file/imageBase64/upload`, params).then(res => res.data)
};
// 标签组列表
export const queryGroupList = params => {
    return post(`/admin/tag/group/list`, params).then(res => res.data)
};
// 标签组删除
export const handleGroupDelete = params => {
    return post(`/admin/tag/group/del`, params).then(res => res.data)
};
// 标签组编辑
export const handleGroupEdit = params => {
    return post(`/admin/tag/group/edit`, params).then(res => res.data)
};
// 标签组添加
export const handleGroupAdd = params => {
    return post(`/admin/tag/group/add`, params).then(res => res.data)
};
// 标签列表
export const queryTagList = params => {
    return post(`/admin/tag/list`, params).then(res => res.data)
};
// 标签类型列表
export const queryTagTypeList = params => {
    return post(`/admin/tag/type/list`, params).then(res => res.data)
};
// 标签添加
export const handleTagAdd = params => {
    return post(`/admin/tag/add`, params).then(res => res.data)
};
// 标签编辑
export const handleTagEdit = params => {
    return post(`/admin/tag/edit`, params).then(res => res.data)
};
// 标签删除
export const handleTagDel = params => {
    return post(`/admin/tag/del`, params).then(res => res.data)
};
// 用户贴标签
export const handleMarkTag = params => {
    return post(`/admin/user/mark_tag`, params).then(res => res.data)
};
// 创建直播
export const handleCreateRoom = params => {
    return post(`/admin/tencent/mini/broadcast/room/create`, params).then(res => res.data)
};
// 小程序直播列表
export const queryWxRoomList = params => {
    return post(`/admin/tencent/mini/broadcast/room/list`, params).then(res => res.data)
};
// 直播删除
export const handleRoomDelete = params => {
    return post(`/admin/tencent/mini/broadcast/room/delete`, params).then(res => res.data)
};
// 新增临时素材
export const handleMediaUpload = params => {
    return post(`/admin/tencent/mini/broadcast/media/upload`, params).then(res => res.data)
};
// 新增百家云直播
export const handleCreateLiveRoom = params => {
    return post(`/admin/bjy/create_live_room`, params).then(res => res.data)
};
// 百家云直播列表
export const queryBjyLiveRoom = params => {
    return post(`/admin/bjy/live_room`, params).then(res => res.data)
};
// 百家云直播删除
export const handleDeleteLive = params => {
    return post(`/admin/bjy/delete_live_room`, params).then(res => res.data)
};
// 添加弹幕
export const handleAddBjyComment = params => {
    return post(`/admin/bjy/gen_comment_job`, params).then(res => res.data)
};
// 获取统计链接
export const queryRedirectLiveData = params => {
    return post(`/admin/bjy/redirect_live_data`, params).then(res => res.data)
};
// 复制直播短链
export const queryGeneratescheme = params => {
    return post(`/admin/bjy/generatescheme`, params).then(res => res.data)
};
// 获取回放信息
export const queryGetLiveInfo = params => {
    return get(`/api/byj/get_live`, params).then(res => res.data)
};
// 获取回放信息
export const queryGetLiveInfoV2 = params => {
    return get(`/api/byj/get_liveV2`, params).then(res => res.data)
};

// 复制课程、目录、大专栏短链
export const queryCourseV2Generatescheme = params => {
    return post(`/admin/courseV2/generatescheme`, params).then(res => res.data)
};

// 复制商品短链
export const queryGenerateUrlLink2Goods = params => {
    return get(`/admin/bjy/generateUrlLink2Goods`, params).then(res => res.data)
};

// h5支付
export const queryBjyH5Pay = params => {
    return post(`/api/byj/jsapi_pay`, params).then(res => res.data)
};
// h5商品详情
export const queryGoodsDetail = params => {
    return post(`/happiness/Client/ClientMall/goodsDetail`, params).then(res => res.data)
};
// h5登录
export const handleH5Login = params => {
    return get(`/api/byj/h5_login`, params).then(res => res.data)
};

// 验证
export const queryWebJsticket = params => {
    return post(`/api/byj/web_jsticket`, params).then(res => res.data)
};
// 获取直播间参数
export const queryGetSign = params => {
    return post(`/api/byj/get_sign`, params).then(res => res.data)
};


// 获取登录验证图形
export const queryGraph = params => {
    return post(`/admin/captcha/graph`, params).then(res => res.data)
};
// 导出用户列表
export const handleExportUser = params => {
    return post(`/admin/user/export`, params).then(res => res.data)
};



// 门店添加
export const handleStoreAdd = params => {
    return post(`/admin/store/add`, params).then(res => res.data)
};
// 门店编辑
export const handleStoreEdit = params => {
    return post(`/admin/store/edit`, params).then(res => res.data)
};
// 门店列表
export const queryStoreList = params => {
    return post(`/admin/store/list`, params).then(res => res.data)
};
// 直播列表
export const queryStorLiveList = params => {
    return post(`/admin/store/live/list`, params).then(res => res.data)
};
// 直播添加
export const handleStorLiveAdd = params => {
    return post(`/admin/store/live/add`, params).then(res => res.data)
};
// 商品添加
export const handleStorGoodsAdd = params => {
    return post(`/admin/store/goods/add`, params).then(res => res.data)
};
// 商品编辑
export const handleStorGoodsEdit = params => {
    return post(`/admin/store/goods/edit`, params).then(res => res.data)
};
// 商品列表
export const queryStorGoodsList = params => {
    return post(`/admin/store/goods/list`, params).then(res => res.data)
};
// 商品订单列表
export const queryStorOrderList = params => {
    return post(`/admin/store/order/list`, params).then(res => res.data)
};
// 新增优惠券
export const handleStoreCouponAdd = params => {
    return post(`/admin/store/coupon/add`, params).then(res => res.data)
};
// 编辑优惠券
export const handleStoreCouponEdit = params => {
    return post(`/admin/store/coupon/edit`, params).then(res => res.data)
};
// 优惠券列表
export const queryStoreCouponList = params => {
    return post(`/admin/store/coupon/list`, params).then(res => res.data)
};
// 优惠券领取列表
export const queryStoreGetCouponList = params => {
    return post(`/admin/store/coupon_get/list`, params).then(res => res.data)
};


// 门店店员列表
export const queryEmployeesList = params => {
    return get(`/admin/store/list_employees`, params).then(res => res.data)
};
// 新增门店店员
export const handleEmployeesAdd = params => {
    return get(`/admin/store/add_employees`, params).then(res => res.data)
};
// 移除门店店员
export const handleEmployeesUnbind = params => {
    return get(`/admin/store/unbind_employees`, params).then(res => res.data)
};
// 新增门店分组
export const handleStoreGroupAdd = params => {
    return post(`/admin/store/group/add`, params).then(res => res.data)
};
// 门店分组列表
export const queryStoreGroupList = params => {
    return post(`/admin/store/group/list`, params).then(res => res.data)
};
// 删除门店分组
export const handleStoreGroupDelete = params => {
    return post(`/admin/store/group/delete`, params).then(res => res.data)
};
// 编辑门店分组
export const handleStoreGroupEdit = params => {
    return post(`/admin/store/group/edit`, params).then(res => res.data)
};
// 加入/移除门店
export const handleStoreJoinGroup = params => {
    return post(`/admin/store/batch_join_group`, params).then(res => res.data)
};
// 添加商品分类
export const handleGoodsCateAdd = params => {
    return post(`/admin/store/goods/cate/add`, params).then(res => res.data)
};
// 编辑商品分类
export const handleGoodsCateEdit = params => {
    return post(`/admin/store/goods/cate/edit`, params).then(res => res.data)
};
// 商品分类列表
export const queryGoodsCateList = params => {
    return post(`/admin/store/goods/cate/list`, params).then(res => res.data)
};
// 商品规格名称管理
export const querySpecOperate = params => {
    return post(`/admin/store/goods/spec_name/operate`, params).then(res => res.data)
};
// 商品详情
export const queryStoreGoodsDetail = params => {
    return get(`/admin/store/goods/detail`, params).then(res => res.data)
};


// 门店批发商品列表
export const queryStoreWholesaleList = params => {
    return post(`/admin/store/wholesale/goods/list`, params).then(res => res.data)
};
// 门店批发商品添加
export const handleAddStoreWholesale = params => {
    return post(`/admin/store/wholesale/goods/add`, params).then(res => res.data)
};
// 门店批发商品编辑
export const handleEditStoreWholesale = params => {
    return post(`/admin/store/wholesale/goods/edit`, params).then(res => res.data)
};
// 门店批发商品详情
export const queryStoreWholesaleDetail = params => {
    return get(`/admin/store/wholesale/goods/detail`, params).then(res => res.data)
};
// 门店批发商品分类
export const queryWholesaleCateOperate = params => {
    return post(`/admin/store/wholesale/goods/cate/operate`, params).then(res => res.data)
};
// 门店批发商品规格管理
export const queryWholesaleSpecOperate = params => {
    return post(`/admin/store/wholesale/goods/spec_name/operate`, params).then(res => res.data)
};
// 门店批发订单列表
export const queryWholesaleOrderList = params => {
    return post(`/admin/store/wholesale/order/list`, params).then(res => res.data)
};
// 门店零售商品列表
export const queryStoreRetailGoodsList = params => {
    return post(`/admin/store/retail/goods/list`, params).then(res => res.data)
};
// 门店零售商品上/下架
export const handleStoreRetailShow = params => {
    return get(`/admin/store/retail/goods/show`, params).then(res => res.data)
};
// 门店零售商品分类
export const queryRetailCateOperate = params => {
    return post(`/admin/store/retail/goods/cate/operate`, params).then(res => res.data)
};
// 门店零售商品规格管理
export const queryRetailSpecOperate = params => {
    return post(`/admin/store/retail/goods/spec_name/operate`, params).then(res => res.data)
};
// 门店零售商品添加
export const handleAddStoreRetail = params => {
    return post(`/admin/store/retail/goods/add`, params).then(res => res.data)
};
// 门店零售商品详情
export const queryStoreRetailDetail = params => {
    return get(`/admin/store/retail/goods/detail`, params).then(res => res.data)
};
// 门店零售商品编辑
export const handleEditStoreRetail = params => {
    return post(`/admin/store/retail/goods/edit`, params).then(res => res.data)
};
// 门店零售订单管理
export const queryRetailOrderList = params => {
    return post(`/admin/store/retail/order/list`, params).then(res => res.data)
};
// 快递公司查询
export const queryDeliveryCompany = params => {
    return post(`/admin/store/delivery_company`, params).then(res => res.data)
};
// 零售商品快递发货
export const handleRetailDelivery = params => {
    return post(`/admin/store/retail/order/delivery`, params).then(res => res.data)
};
// 运费模板列表
export const queryFreightTemplateList = params => {
    return post(`/admin/store/freight_template_list`, params).then(res => res.data)
};
// 运费模板添加
export const handleFreightTemplateAdd = params => {
    return post(`/admin/store/freight_template_add`, params).then(res => res.data)
};
// 运费模板编辑
export const handleFreightTemplateEdit = params => {
    return post(`/admin/store/freight_template_edit`, params).then(res => res.data)
};
// 运费模板规则列表
export const queryFreightTemplateRuleList = params => {
    return post(`/admin/store/freight_template_rule_list`, params).then(res => res.data)
};
// 运费模板规则新增
export const handleFreightTemplateRuleAdd = params => {
    return post(`/admin/store/freight_template_rule_add`, params).then(res => res.data)
};
// 运费模板规则编辑
export const handleFreightTemplateRuleEdit = params => {
    return post(`/admin/store/freight_template_rule_edit`, params).then(res => res.data)
};
// 模板城市列表
export const queryDistrictList = params => {
    return post(`/admin/system/district_list`, params).then(res => res.data)
};
// 模板列表删除
export const handleFreightTemplateDel = params => {
    return post(`/admin/store/freight_template_del`, params).then(res => res.data)
};
// 模板规则列表删除
export const handleFreightTemplateRuleDel = params => {
    return post(`/admin/store/freight_template_rule_del`, params).then(res => res.data)
};
// 快递公司列表
export const queryExpressDelivery = params => {
    return post(`/admin/store/delivery_company`, params).then(res => res.data)
};
// 团队审核列表
export const queryTeamReviewList = params => {
    return post(`/admin/team/review_list`, params).then(res => res.data)
};
// 团队审核通过
export const handleTeamReviewPass = params => {
    return get(`/admin/team/pass_review`, params).then(res => res.data)
};
// 团队审核不通过
export const handleTeamReviewReject = params => {
    return post(`/admin/team/reject_review`, params).then(res => res.data)
};
// 团队关系列表
export const queryTeamRelationList = params => {
    return post(`/admin/team/relation_list`, params).then(res => res.data)
};
// 分销比例列表
export const queryTeamRewardRateList = params => {
    return post(`/admin/team/reward_rate_list`, params).then(res => res.data)
};
// 编辑分销比例
export const handleTeamRewardRateUpdate = params => {
    return post(`/admin/team/reward_rate_update`, params).then(res => res.data)
};
// 门店零售已发货订单退款【仅限已发货和备货中】
export const handleRetailrefundApprove = params => {
    return post(`/admin/store/retail/order/refund_approve`, params).then(res => res.data)
};
// 门店零售已完成订单退款
export const handleRetailFinishrefund = params => {
    return post(`/admin/store/retail/order/finish_refund`, params).then(res => res.data)
};


// 推送管理
export const querySubscribeTemplateList = params => {
    return post(`/admin/wx_mini/subscribe_template_list`, params).then(res => res.data)
};
// 发送推送消息
export const handleSendSubscribeMsg = params => {
    return post(`/admin/wx_mini/send_subscribe_msg`, params).then(res => res.data)
};


// 短视频合集
export const queryShortVideoCatalog = params => {
    return post(`/admin/short_video/catalog/list`, params).then(res => res.data)
};
// 短视频评论列表
export const queryShortVideoCommentList = params => {
    return post(`/admin/short_video/comment_list`, params).then(res => res.data)
};
// 短视频评论下架
export const handleShortVideoCommentDel = params => {
    return post(`/admin/short_video/comment_del`, params).then(res => res.data)
};
// 短视频合集添加
export const handleShortVideoCatalogAdd = params => {
    return post(`/admin/short_video/catalog/add`, params).then(res => res.data)
};
// 短视频合集编辑
export const handleShortVideoCatalogEdit = params => {
    return post(`/admin/short_video/catalog/update`, params).then(res => res.data)
};
// 添加合集下短视频
export const handleShortVideoBatchAdd = params => {
    return post(`/admin/short_video/batch_add`, params).then(res => res.data)
};
// 合集下短视频列表
export const queryShortVideoList = params => {
    return post(`/admin/short_video/list`, params).then(res => res.data)
};
// 编辑合集下短视频
export const handleShortVideoBatchEdit = params => {
    return post(`/admin/short_video/update`, params).then(res => res.data)
};








// 短剧合集
export const queryShortPlayCatalog = params => {
    return post(`/admin/short_drama/catalog/list`, params).then(res => res.data)
};
// 短剧合集添加
export const handleShortPlayCatalogAdd = params => {
    return post(`/admin/short_drama/catalog/add`, params).then(res => res.data)
};
// 短剧合集编辑
export const handleShortPlayCatalogEdit = params => {
    return post(`/admin/short_drama/catalog/update`, params).then(res => res.data)
};
// 添加合集下短剧
export const handleShortPlayBatchAdd = params => {
    return post(`/admin/short_drama/batch_add`, params).then(res => res.data)
};
// 合集下短剧列表
export const queryShortPlayList = params => {
    return post(`/admin/short_drama/list`, params).then(res => res.data)
};
// 编辑合集下短剧
export const handleShortPlayBatchEdit = params => {
    return post(`/admin/short_drama/update`, params).then(res => res.data)
};


// 学习管理列表
export const queryStudyCatalogList = params => {
    return post(`/admin/study/catalog/list`, params).then(res => res.data)
};
// 学习管理添加合集
export const handleStudyCollectionAdd = params => {
    return post(`/admin/study/collection/add`, params).then(res => res.data)
};
// 学习管理合集列表
export const queryStudyCollectionList = params => {
    return post(`/admin/study/collection/list`, params).then(res => res.data)
};
// 学习管理编辑合集
export const handleStudyCollectionEdit = params => {
    return post(`/admin/study/collection/update`, params).then(res => res.data)
};
// 添加合集下学习资料管理
export const handleStudyAdd = params => {
    return post(`/admin/study/add`, params).then(res => res.data)
};
// 合集下学习资料管理列表
export const queryStudyList = params => {
    return post(`/admin/study/list`, params).then(res => res.data)
};
// 添加合集下学习资料管理
export const handleStudyEdit = params => {
    return post(`/admin/study/update`, params).then(res => res.data)
};


// 短视频数据统计
export const queryShortVideoDataMonitor = params => {
    return post(`/admin/short_video/ad_data_monitor`, params).then(res => res.data)
};
// 短视频用户数据明细
export const queryUserShortVideoDataMonitor = params => {
    return post(`/admin/short_video/ad_data_monitor_user`, params).then(res => res.data)
};
// 短剧数据统计
export const queryShortDramaDataMonitor = params => {
    return post(`/admin/short_drama/ad_data_monitor`, params).then(res => res.data)
};
// 短剧用户数据明细
export const queryUserShortDramaDataMonitor = params => {
    return post(`/admin/short_drama/ad_data_monitor_user`, params).then(res => res.data)
};
// 学习数据统计
export const queryStudyDataMonitor = params => {
    return post(`/admin/study/ad_data_monitor`, params).then(res => res.data)
};
// 学习用户数据明细
export const queryUserStudyDataMonitor = params => {
    return post(`/admin/study/ad_data_monitor_user`, params).then(res => res.data)
};
// 签到数据统计
export const querySignDataMonitor = params => {
    return post(`/admin/gold/sign_ad_data_monitor`, params).then(res => res.data)
};
// 签到用户数据明细
export const queryUserSignDataMonitor = params => {
    return post(`/admin/gold/sign_ad_data_monitor_user`, params).then(res => res.data)
};
// 精选数据统计
export const queryWatchVideoDataMonitor = params => {
    return post(`/admin/gold/watch_video_data_monitor`, params).then(res => res.data)
};
// 精选用户数据统计
export const queryUserWatchVideoDataMonitor = params => {
    return post(`/admin/gold/watch_video_data_monitor_user`, params).then(res => res.data)
};